import { generateAvatar } from '../../../utils';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const GroupsPop = ({ group }) => {

    return (
        <div className="group_icon_modal">
            <h1 className="mb_4">Courses Group</h1>
            <div className="table_responsive fullWidth vert_scroll">
                <SkeletonTheme
                    baseColor="#ebebeb"
                    highlightColor="#f5f5f5"
                    borderRadius="0.5rem"
                    duration={4}
                >
                    <table className="table">
                        <tbody>
                            <tr>
                                <th>Name</th>
                                <td>{!group ? <Skeleton /> : group?.name}</td>
                            </tr>
                            <tr>
                                <th>Bio</th>
                                {!group ? <td><Skeleton /></td> : <td dangerouslySetInnerHTML={{ __html: group?.bio_raw }}></td>}
                            </tr>
                            <tr>
                                <th>Cover Image</th>
                                <td>{!group ? <Skeleton /> : <img src={group?.cover_image} alt="" height="80" className="radius_5" />}</td>
                            </tr>
                            <tr>
                                <th>Logo</th>
                                <td>{!group ? <Skeleton /> : <img src={group?.logo ? group?.logo : group && generateAvatar(group?.name)} alt="" height="40" className="group_logo_icon" />}</td>
                            </tr>
                        </tbody>
                    </table>
                </SkeletonTheme>
            </div>
        </div>
    )
};

export default GroupsPop